var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.04 16.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #667085;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke-width: 2px;\n      }\n\n      .cls-3 {\n        stroke-width: 1.75px;\n      }\n\n      .cls-4 {\n        fill: #667085;\n        stroke-width: .75px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.88,
    y: 2.89,
    width: 13.29,
    height: 12.89,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.1,
    y1: 6.32,
    x2: 13.95,
    y2: 6.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m5.92,13.22v-.77h1.31v.77h-1.31Zm.07-3.79v-.82l1.17-.43v.84l-1.17.41Zm1.17,3.79v-5.03h.86v5.03h-.86Zm.79,0v-.77h1.17v.77h-1.17Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.78,
    y1: 1,
    x2: 4.78,
    y2: 4.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.26,
    y1: 1,
    x2: 10.26,
    y2: 4.19
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvent);
export default __webpack_public_path__ + "static/media/icon_event.d9e5029f45b9289999678d8965a8b3af.svg";
export { ForwardRef as ReactComponent };